(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Phase
   *
   * @description
   *
   */
  angular
      .module('neo.services')
      .factory('Phase', Phase);

  function Phase($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/phases/:phaseId', {phaseId: '@_phaseId'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: false
      }
    });
  }
}());
